import { render, staticRenderFns } from "./DDLoading.vue?vue&type=template&id=c6265bd6&scoped=true&"
import script from "./DDLoading.vue?vue&type=script&lang=js&"
export * from "./DDLoading.vue?vue&type=script&lang=js&"
import style0 from "./DDLoading.vue?vue&type=style&index=0&id=c6265bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6265bd6",
  null
  
)

export default component.exports